import PropTypes from 'prop-types';
import { values } from 'ramda';

export const CLASSIFICATION = {
  EVENTS: 'event',
  PUBLICATION: 'publication',
  NEWS: 'news',
  INNOVATION: 'innovations',
  STARTUP: 'startup',
  INNER_PAGE: 'inner-page',
};
// test
export const ClassificationType = PropTypes.oneOf(values(CLASSIFICATION));
